import $ from 'jquery';
import Cookies from 'js-cookie';
import 'remodal';
import '../../node_modules/remodal/dist/remodal.css';
import '../../node_modules/remodal/dist/remodal-default-theme.css';

const template = `<div class="notification-wrapper">
	<a class="notification" id="main_notification" href="https://www.graydigitalgroup.com/contact/">
		<span class="title">How can we help?</span><br/>
		Let us know what’s going on in your digital world.
	</a>

	<a class="close" id="close_notification" href="#">Close</a>
</div>`;


$('body').prepend(template);


/**
 * Function to dismiss notification
 * and set cookies to prevent the notification
 * from opening again
 *
 * @method close_semrush_notification
 */
function close_semrush_notification() {
	$('#close_notification, #main_notification').removeClass('open');

	Cookies.set('close_notification', 'closed');
}

/*
 * If the user clicks the close button,
 * remove the notification and set cookie
 * so prevent it from poping up again
 *
 */
$('#close_notification').on('click', function(event) {
	event.preventDefault();

	$('#close_notification, #main_notification').removeClass('open');
});

/**
 * When the modal window is dismissed
 * lets set the cookie to stop the
 * notification from poping up and then
 * dismiss the existing notification
 */
$(document).on('closed', '.semrush-notification', function () {
	close_semrush_notification();
});

// Display notification after 15sec
window.setTimeout(function() {
	if (Cookies.get('close_notification') !== 'closed') {
		$('#close_notification, #main_notification').addClass('open');
	}
}, 15000);

// Initialize SEMRUSH
new SEMRUSH.SiteauditWidget({ // eslint-disable-line no-undef
	widgetApiKey: '592d77935f50e972b3a9ccf4'
});



// WEBPACK FOOTER //
// ./theme_components/js/semrush.js